import { Link } from "react-router-dom";
import { QrCode } from "@phosphor-icons/react";
import { useLang } from "../context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  const l = t.footer.links;
  const goTo = (sel) => {
    if (window.__lenis) window.__lenis.scrollTo(sel, { offset: -64 });
    else document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="bg-[#0A0F1A] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 md:gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <div className="flex h-8 w-8 items-center justify-center bg-emerald-500 rounded-[4px]">
                <QrCode size={18} weight="bold" className="text-[#04170F]" />
              </div>
              <span className="font-display font-bold text-lg">Certifico<span className="text-emerald-500">QR</span></span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
            <p className="mt-6 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-emerald-500/80">UE 2023/1230 · ISO 9001</p>
          </div>

          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">{t.footer.product}</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><button onClick={() => goTo("#features")} className="hover:text-emerald-400 transition-colors" data-testid="footer-features-link">{l.features}</button></li>
              <li><button onClick={() => goTo("#how")} className="hover:text-emerald-400 transition-colors" data-testid="footer-how-link">{l.how}</button></li>
              <li><Link to="/login" className="hover:text-emerald-400 transition-colors">{l.dashboard}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">{t.footer.legal}</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><Link to="/legal/privacy" className="hover:text-emerald-400 transition-colors" data-testid="footer-privacy-link">{l.privacy}</Link></li>
              <li><Link to="/legal/terms" className="hover:text-emerald-400 transition-colors" data-testid="footer-terms-link">{l.terms}</Link></li>
              <li><Link to="/legal/cookie" className="hover:text-emerald-400 transition-colors" data-testid="footer-cookie-link">{l.cookie}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">{t.footer.company}</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li><Link to="/about" className="hover:text-emerald-400 transition-colors" data-testid="footer-about-link">{l.about}</Link></li>
              <li><a href="mailto:certificoqr@aldebran.com" className="hover:text-emerald-400 transition-colors" data-testid="footer-contact-link">{l.contact}</a></li>
              <li><a href="mailto:certificoqr@aldebran.com" className="hover:text-emerald-400 transition-colors" data-testid="footer-support-link">{l.support}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Certifico QR. {t.footer.rights}</p>
          <p className="font-mono-tech text-[11px] text-slate-600" data-testid="footer-contacts">
            <a href="mailto:certificoqr@aldebran.com" className="hover:text-emerald-400 transition-colors">certificoqr@aldebran.com</a>
            {" · "}
            <a href="tel:+390350167428" className="hover:text-emerald-400 transition-colors">+39 035 0167428</a>
          </p>
        </div>
      </div>

      <div className="overflow-hidden border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-12 py-4">
          <h2 className="font-display font-bold text-[clamp(48px,9vw,130px)] leading-none tracking-tighter text-white/5 select-none">CERTIFICO QR</h2>
        </div>
      </div>
    </footer>
  );
};
